import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import SOPTaskTable from "./SOPTaskTable";
import SOPInfo from "./SOPInfo";
import { useTranslation } from "react-i18next";

const ViewSOP = () => {
  const { t } = useTranslation();

  useEffect(() => {
    GridStack.init();
  }, []);

  const { state } = useLocation();
  let sop_instance_data = state?.data;
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t("viewsopinfo")}
          showmenu={true}
          showIconsForback={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 2,
      width: 12,
      height: 6,
      id: 1,
      component: <SOPInfo sopInstanceData={sop_instance_data} />,
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 6,
      width: 12,
      height: 10,
      id: 2,
      component: <SOPTaskTable sopInstanceData={sop_instance_data} />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default ViewSOP;
